import {
  Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
} from '@triare/auth-redux';
import {
  put, delay, takeLatest, call,
} from 'redux-saga/effects';
import { actions, CategoryAndSubCategory, SubCategoryShort } from './index';
import { PaginatedResponse, PaginationProps } from '../types';

export type CategoryListAllData = CategoryAndSubCategory;

export type CategoryListAllResponse = PaginatedResponse<CategoryListAllData>;

export type CategoryListAll = PaginationProps & {
  orderByColumn?: 'id' | 'name' | 'createdAt' | 'updatedAt';
  search?: string;
}

export const categoryListAll = (payload: CategoryListAll): Action<CategoryListAll> => ({
  type: actions.categoryListAllTrigger.toString(),
  payload,
});

export const categoryListAllClear = (): Action => ({
  type: actions.categoryListAllClear.toString(),
});
export const categoryListAllErrorClear = (): Action => ({
  type: actions.categoryListAllErrorReset.toString(),
});

export function* categoryListAllRequestSaga({ payload }: Action<CategoryListAll>) {
  yield put({
    type: actions.categoryListAllStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.categoryListAllError.toString(),
      payload: {
        message: 'CategoryListAll: Parameters not passed.',
      },
    });

    return;
  }

  const response = (yield call(
    fetchAuthSaga,
    `${config.api.url}categories/all?${new URLSearchParams(payload).toString()}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<CategoryListAllResponse, CategoryListAllResponse>(
    response,
    actions.categoryListAllSuccess.toString(),
    actions.categoryListAllError.toString(),
    false,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.categoryListAllTrigger.toString(),
    defaultProcessingSaga(
      categoryListAllRequestSaga,
      {
        error: actions.categoryListAllError.toString(),
        locationCancel: actions.categoryListAllClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.categoryListAllSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }

    // yield put({
    //   type: actions.categoryListAllClear.toString(),
    // });
  });

  yield takeLatest(actions.categoryListAllError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.categoryListAllErrorReset.toString(),
    });
  });
}
